module.exports = __webpack_public_path__ + "static/media/heart.337ae6f3.png";